import React from "react";
import AdminLayout, { NavigationItem } from "../admin/AdminLayout";
import {
  HomeIcon,
  BriefcaseIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";

const hiringManagerNavigation: NavigationItem[] = [
  {
    name: "Dashboard",
    href: "/hiring-manager",
    icon: HomeIcon,
    color: "from-blue-500 to-blue-600",
    bgColor: "bg-blue-500",
  },
  {
    name: "My Jobs",
    href: "/hiring-manager/jobs",
    icon: BriefcaseIcon,
    color: "from-orange-500 to-orange-600",
    bgColor: "bg-orange-500",
  },
  {
    name: "Interview Management",
    href: "/hiring-manager/interview-management",
    icon: DocumentTextIcon,
    color: "from-teal-500 to-teal-600",
    bgColor: "bg-teal-500",
  },
];

const HiringManagerLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AdminLayout
      navigationItems={hiringManagerNavigation}
      sidebarKey="hmSidebarCollapsed"
      showChatNotifications={false}
    >
      {children}
    </AdminLayout>
  );
};

export default HiringManagerLayout;
